export type KrFormViewProps = {
    data: any
}

export enum ReasearchButtons {
    SearchDocument,
    AddDocumentProposal,
    SearchPublication,
    AddPublicationProposal
}

export enum GenesisAndAgeTypes {
    Creation = 1,
    Development
}

export enum ConductingObservationTypes {
    SurfaceMonitoring = 1,
    InDepthMonitoring,
    SurfaceAndInDepthMonitoring
}

export enum RasterType {
    Image = "foto",
    CrossSection = "przekroj",
    Map = "mapa_u",
    Sketch = "szkic"
}

export enum MonitoringType {
    Documentation = "Dokumentacja",
    Raports = "Raporty"
}